import { HorizontalSpacer, Label, Layout, Panel, Switch } from "@mcleod/components";

export abstract class AutogenLayoutConfirmOrderSave extends Layout {
    confirmLabel: Label;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    mainPanel: Panel;
    saveToOrderSwitch: Switch;
}
